/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { MidasEffectError, IOverviewAction } from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';

export const queryOverviewActions = createAction(
  '[OverviewActions] Query OverviewActions',
  props<{ limit: number; offset: number }>(),
);

export const queryOverviewActionsSuccess = createAction(
  '[OverviewActions] Query OverviewActions Success',
  props<{ carts: IOverviewAction[]}>(),
);
export const queryOverviewActionsError = createAction(
  '[OverviewActions] Query OverviewActions Error',
  props<MidasEffectError>(),
);


export const queryOverviewActionsBySearchValue = createAction(
  '[OverviewActions] Query OverviewAction By Search Value',
  props<{ searchValue: string, statusIds: string[], locationIds: number[]}>(),
);

export const queryOverviewactionsBySearchValueSuccess = createAction(
  '[OverviewActions] Query OverviewAction By Search Value Success',
  props<{carts: IOverviewAction[] }>(),
);

export const queryOverviewactionsBySearchValueError = createAction(
  '[OverviewActions] Query OverviewAction By Search Value Error',
  props<MidasEffectError>(),
);
